import { render } from "./LibroDeiSalmi.vue?vue&type=template&id=5298bd38"
import script from "./LibroDeiSalmi.vue?vue&type=script&lang=js"
export * from "./LibroDeiSalmi.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__